var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "risolto-timeline block" },
    [
      _c(
        "el-timeline",
        [
          _vm._l(_vm.timelineItemComponents, function(item, index) {
            return [
              _c(
                "el-timeline-item",
                {
                  key: index,
                  attrs: {
                    icon: _vm._f("timelineIconFilter")(item.channel),
                    type: item.type,
                    color: item.color,
                    size: "xxlarge",
                    timestamp: _vm.timestampGenerator(item),
                    placement: "top"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "dot",
                        fn: function() {
                          return [
                            _c(
                              "div",
                              { staticClass: "icon-stack" },
                              [
                                _c("span", { staticClass: "dot" }),
                                _vm._v(" "),
                                _c("svg-icon", {
                                  staticClass: "icon",
                                  staticStyle: { "font-size": "30px" },
                                  attrs: {
                                    "icon-class": _vm._f("timelineIconFilter")(
                                      item.channel
                                    )
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                },
                [
                  _vm._v(" "),
                  _c(item.component, {
                    key: index,
                    tag: "component",
                    attrs: { item: item }
                  })
                ],
                1
              )
            ]
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.showLoadMore
        ? _c("div", { staticClass: "text-center" }, [
            _c(
              "span",
              { staticClass: "loadMoreSpan", on: { click: _vm.loadMore } },
              [
                _vm._v(" " + _vm._s(_vm.$t("loadMore")) + "..."),
                _c("i", { staticClass: "el-icon-view el-icon--right" })
              ]
            )
          ])
        : _c("div", { staticClass: "text-center" }, [
            _c("p", [_c("i", [_vm._v(_vm._s(_vm.$t("thatsAll")))])])
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }